import React, { useState } from 'react';
import { Bot, X } from 'lucide-react';
import { WHATSAPP_LINK } from '../constants';

const QUICK_ACTIONS = [
  { label: '📉 Perder menos clientes', href: WHATSAPP_LINK, external: true },
  { label: '💰 ¿Cuánto cuesta?', href: '#pricing' },
];

export const Chatbot: React.FC = () => {
  const [isVisible, setIsVisible] = useState(true);

  const handleActionClick = (href: string, external?: boolean) => {
    if (external) {
      window.open(href, '_blank');
    } else {
      const el = document.querySelector(href);
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  if (!isVisible) return null;

  return (
    <div
      className="fixed bottom-20 md:bottom-6 right-4 md:right-6 z-50 flex flex-col items-end gap-3 transition-all duration-500 opacity-100 translate-y-0"
      style={{ maxWidth: 'calc(100vw - 32px)' }}
    >
      <button
        onClick={() => setIsVisible(false)}
        className="self-end mb-1 p-1.5 rounded-full bg-slate-200/80 hover:bg-slate-300 text-slate-500 transition-colors"
        aria-label="Cerrar"
      >
        <X size={14} />
      </button>

      <div className="bg-white rounded-2xl rounded-br-md shadow-2xl border border-slate-200 px-3.5 py-3 max-w-[260px] md:max-w-[320px] cursor-pointer hover:shadow-3xl transition-shadow">
        <div className="flex items-center gap-2 mb-1.5">
          <div
            className="w-6 h-6 rounded-full flex items-center justify-center flex-shrink-0"
            style={{ background: 'linear-gradient(135deg, #2B5F6F, #3CB371)' }}
          >
            <Bot size={12} className="text-white" />
          </div>
          <span className="text-xs font-bold text-slate-500">Ancora AI</span>
          <span className="w-1.5 h-1.5 rounded-full bg-green-400 animate-pulse" />
        </div>
        <p className="text-[13px] text-slate-800 leading-snug">
          👋 ¿Sabes cuántos clientes se te escapan cada semana por contestar tarde?
        </p>
      </div>

      <div className="flex flex-col gap-1.5 w-full max-w-[260px] md:max-w-[320px]">
        {QUICK_ACTIONS.map((action, i) => (
          <button
            key={action.label}
            onClick={() => handleActionClick(action.href, action.external)}
            className={`w-full text-left px-3 py-2.5 rounded-2xl rounded-bl-md text-[13px] font-medium transition-all duration-200 hover:-translate-y-0.5 ${
              i === 0
                ? 'bg-slate-900 text-white hover:bg-slate-800 shadow-lg'
                : 'bg-white text-slate-700 border border-slate-200 hover:bg-slate-50 hover:border-slate-300 shadow-md'
            }`}
          >
            {action.label}
          </button>
        ))}
      </div>
    </div>
  );
};
